import { Button, makeStyles, Typography } from '@material-ui/core';
import { useCustomDomainData } from 'common/hooks/useCustomDomain';
import { Enum_Connected_Domain_State_Enum } from 'common/schema/commonSchemaRemoteTypes';
import { languageLocalesList } from 'common/utils/languageUtils';
import React, { useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { DashboardRoutesConfig } from 'stacks/Dashboard/common/DashboardRoot/configs/routesConfigs';
import { CDNUrl, KALEIDO_URL } from 'utils/constants';
import { getArtistUrl } from 'utils/utilFunctions';

const SRC_DEFAULT = `${CDNUrl}/images/customDomain/ZeroStateBackground.png`;

const useStyles = makeStyles(() => ({
  container: {
    backgroundImage: `url(${SRC_DEFAULT})`,
    backgroundPosition: 'center bottom',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    gap: 40,
  },
  button: {
    margin: '16px auto',
  },
}));

function getKaleidoUrl(relativePath: string) {
  return `${KALEIDO_URL}${relativePath}`;
}

const ZeroStateDomainOffline: React.FC = () => {
  const classes = useStyles();
  const { t, i18n } = useTranslation();
  const { domain } = useCustomDomainData();
  useEffect(() => {
    if (!domain?.preferredLanguage) {
      return;
    }
    i18n.changeLanguage(languageLocalesList[domain.preferredLanguage]);
  }, [i18n, domain?.preferredLanguage]);

  return (
    <div className={classes.container}>
      <img src={`${CDNUrl}/images/customDomain/OfflineIcon.svg`} alt="offline" />
      <Typography variant="h5">{t('customDomain.offline.title')}</Typography>
      {domain?.status === Enum_Connected_Domain_State_Enum.Disabled && (
        <>
          <div>
            {t('customDomain.offline.artistInfo')
              .split('\n')
              .map((item, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <Typography variant="body1" key={`artist-info-${index}`}>
                  {item}
                </Typography>
              ))}
            <Typography variant="body1">
              <Trans i18nKey="customDomain.offline.visitKaleidoDashboard">
                <a href={getKaleidoUrl(DashboardRoutesConfig.myWebsite)} target="_blank" rel="noreferrer">
                  profile
                </a>
              </Trans>
            </Typography>
          </div>
          <div>
            <Typography variant="body1">{t('customDomain.offline.resolution')}</Typography>
            <Button
              variant="contained"
              color="primary"
              className={classes.button}
              href={getKaleidoUrl(
                getArtistUrl({
                  handle: domain?.profileHandle,
                })
              )}
              target="_blank"
            >
              {t('customDomain.offline.goToProfile')}
            </Button>
          </div>
        </>
      )}
    </div>
  );
};

export default ZeroStateDomainOffline;
